import { useRef, useState } from "react";
import { toast } from "sonner";
import { Loader2, Upload } from "lucide-react";
import api, { formatApiErrorDetail } from "../../lib/api";

export default function UploadButton({ onUploaded, testid, label = "Upload photo" }) {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);

  const onChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/admin/upload", fd);
      onUploaded(`${process.env.REACT_APP_BACKEND_URL}/api/files/${data.path}`);
      toast.success("Photo uploaded");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setBusy(false);
      e.target.value = "";
    }
  };

  return (
    <>
      <input ref={inputRef} type="file" accept="image/*" className="hidden" onChange={onChange} data-testid={`${testid}-file`} />
      <button
        type="button"
        onClick={() => inputRef.current?.click()}
        disabled={busy}
        data-testid={testid}
        className="inline-flex items-center gap-1.5 rounded-full bg-lavender-100 px-4 py-2 text-xs font-semibold text-lavender-800 transition-colors hover:bg-lavender-200 disabled:opacity-60"
      >
        {busy ? <Loader2 size={13} className="animate-spin" /> : <Upload size={13} />}
        {busy ? "Uploading…" : label}
      </button>
    </>
  );
}
